import type { SearchParams } from "../types/Router";
import qs from "qs";

export const getSearchQuery = (query: Partial<SearchParams>): string =>
  qs.stringify(query, { addQueryPrefix: true, indices: false });
